import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
    Sizes,
    AlternateAnchor,
    MessagePropType,
    messageToString,
    IconChooser,
    IconMapLazy,
} from '@ratehub/base-ui';
import { useIntl } from 'react-intl';


function AccountDetailsHeader({ iconKey, title, ctaLabel, startQuoteHREF, showCTA, ...otherProps }) {
    const intl = useIntl();
    const dataNameSuffix = messageToString(title, intl);
    const isIconEnabled = !!iconKey;

    return (
        <AccountDetailsHeader.FlexContainer
            isIconEnabled={isIconEnabled}
            {...otherProps}
        >
            <Choose>
                <When condition={isIconEnabled}>
                    <div className="iconContainer">
                        <IconChooser
                            iconKey={iconKey}
                            size="M"
                        />

                        <h2 className={'rh-title-l rh-m-0 rh-ml-1_5'}>
                            {title}
                        </h2>
                    </div>
                </When>
                <Otherwise>
                    <h2 className={'rh-title-m rh-mt-0 rh-mb-1 titleContainer'}>
                        {title}
                    </h2>
                </Otherwise>
            </Choose>
            <If condition={showCTA}>
                <AlternateAnchor
                    className="startQuoteCTA"
                    href={startQuoteHREF}
                    size="medium"
                    data-name={`Dashboard-startNewCTA-${dataNameSuffix}`}
                    message={ctaLabel}
                />
            </If>
        </AccountDetailsHeader.FlexContainer>
    );
}

AccountDetailsHeader.propTypes = {
    iconKey: PropTypes.oneOf(Object.keys(IconMapLazy)),
    title: PropTypes.node.isRequired,
    ctaLabel: MessagePropType,
    startQuoteHREF: PropTypes.string,
    showCTA: PropTypes.bool,
};

AccountDetailsHeader.defaultProps = {
    iconKey: undefined,
    ctaLabel: undefined,
    startQuoteHREF: undefined,
    showCTA: true,
};

AccountDetailsHeader.FlexContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    margin-top: ${props => props.isIconEnabled
        ? `-${Sizes.SPACING.ONE_AND_A_HALF};`
        : `-${Sizes.SPACING.THREE_QUARTERS};`}
    padding-bottom: ${props => props.isIconEnabled ? Sizes.SPACING.THREE : 0};
    > .iconContainer {
        display: flex;
        align-items: center;
        margin-top: ${Sizes.SPACING.ONE};
        flex: 65% 1 0;
    }
    > .titleContainer {
        flex: 65% 1 0;
    }
    > .startQuoteCTA {
        flex: 175px 1 0;
        ${props => props.isIconEnabled && `
            margin-top: ${Sizes.SPACING.ONE};
        `}
        ${props => !props.isIconEnabled && `
            margin-bottom: ${Sizes.SPACING.ONE};
        `}
    }
`;

export default AccountDetailsHeader;
